import axios from '../../axios'
import { makeObservable } from 'mobx'
// import { toast } from 'react-toastify'
import { ObjectType } from './types'

export class PredictionStore {
  constructor() {
    makeObservable(this, {})
  }

  reset = () => {}

  hideObject = async (objectType: ObjectType, objectId: number) => {
    return await axios
      .put(`/prediction-services/api/v1/user/objectConfig/hide`, {
        objectType: objectType,
        objectId: objectId,
      })
      .then(({ data }) => data)
  }

  unHideObject = async (objectType: ObjectType, objectId: number) => {
    return await axios
      .put(`/prediction-services/api/v1/user/objectConfig/unhide`, {
        objectType: objectType,
        objectId: objectId,
      })
      .then(({ data }) => data)
  }
}

export const predictionStore = new PredictionStore()
